import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import SimpleAlert from "../../components/AtutaAlerts/CustomAlerts";
import { Link } from "react-router-dom";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

const useStyles = makeStyles(styles);

export default function WhyUs() {
  const [cardAnimation, setCardAnimation] = useState("cardHidden");
  const [alertMessage, setAlertMessage] = useState("");
  const isMountedRef = useRef(true);
  const classes = useStyles();

  useEffect(() => {
    isMountedRef.current = true;
    const id = setTimeout(() => {
      if (isMountedRef.current) setCardAnimation("");
    }, 300);

    return () => {
      isMountedRef.current = false;
      clearTimeout(id);
    };
  }, []);

  const features = [
    "Your identity using private data is kept confidential; others see only your nickname. Your privacy is paramount.",
    "Engage in live video conferencing with your partner — easily toggle this feature on or off as you prefer.",
    "Experience live audio conversations — this feature can also be toggled on or off. Both audio and video features become available only after a mutual 'like' has been established, ensuring comfortable interactions.",
    "Enjoy seamless live chat for instant communication.",
    "You have full control to hide or unhide your pictures from all other users at any time.",
    "Easily block users you prefer not to interact with. Blocked users will be unable to send you messages, or initiate audio or video calls.",
    "Discover your preferred matches using your own criteria. Our platform relies on genuine connections, not automated suggestions.",
    "Access all features, including premium functionalities, with a single, transparent price — no hidden fees or extra charges.",
  ];

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={10} md={8}>
          <Card login className={classes[cardAnimation]}>
            <CardHeader
              className={`${classes.cardHeader} ${classes.textCenter}`}
              color="rose"
            >
              <h4 className={classes.cardTitle}>Why We Stand Out</h4>
            </CardHeader>
            <CardBody>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {features.map((text, idx) => (
                  <li
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "15px",
                      marginBottom: "20px",
                      fontSize: "14px",
                      lineHeight: "1.6",
                    }}
                  >
                    <CheckCircleIcon
                      style={{
                        color: "#4caf50",
                        fontSize: "1.8rem",
                        marginTop: "4px",
                      }}
                    />
                    <span>{text}</span>
                  </li>
                ))}
              </ul>
            </CardBody>
            <CardFooter className={classes.justifyContentCenter}>
              <Link
                to="/dashboard/singles"
                style={{
                  color: "#9c27b0",
                  textDecoration: "none",
                  fontSize: "1rem",
                  fontWeight: "bold",
                }}
              >
                Go to Home Page
              </Link>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>

      {alertMessage && (
        <SimpleAlert
          message={alertMessage}
          onClose={() => setAlertMessage("")}
        />
      )}
    </div>
  );
}
